<template>
  <div class="contactListInnerMain" :style="cssProps">
    <div class="topBar">
      <a class="closeColumnBtn" @click="closeContactsListColumn()">
        <img src="@/assets/images/left-arrow.png" />
      </a>
      <div class="topBarTitle">
        Yeni Sohbet
      </div>
    </div>
    <div class="searchBar">
      <div class="searchBarLeftIcon" />
      <input ref="searchInput" @keyup="changeSearchKeyWithTimer($event.target.value)" placeholder="Kişilerde ara" />
      <div class="searchBarRightIcon" />
    </div>
    <div class="contactListContainer">
      <div class="newGroupContainer" @click="createNewGroupClicked">
        <div class="newGroupIcon" />
        <div>Yeni Grup</div>
      </div>

      <div v-for="letter in letters" :key="letter + 'KK'">
        <div class="letterHeader" v-if="getLetterFilteredContacts(letter).length > 0">
          {{ letter }}
        </div>
        <div class="contactRowWrapper">
          <ContactRow v-for="contact in getLetterFilteredContacts(letter)" :key="contact.UserID" :contact="contact" @click.native="addNewConversation(contact)" v-waypoint="waypointOptions" :data-photourl="contact.PhotoURL == null ? '@/assets/images/nophoto.png' : contact.PhotoURL" :data-contact="JSON.stringify(contact)" :data-visiblename="contact.VisibleName" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/eventbus.js'
import ContactRow from './ContactRow.vue'
import { messageMixin } from '@/mixins/messageMixin.js'
var moment = require('moment')
var CryptoJS = require('crypto-js')
export default {
  components: {
    ContactRow
  },
  mixins: [messageMixin],

  computed: {
    cssProps() {
      return {
        '--topBarColor': this.$config.theme.default.sideMenu.topBarColor,
        '--fontColor': this.$config.theme.default.sideMenu.fontColor,
        '--buttonColor': this.$config.theme.default.sideMenu.buttonColor
      }
    },
    letters() {
      let a = 'ABCÇDEFGHIİJKLMNOÖPRSŞTUÜVYZ'.split('')
      return a
    }
  },

  data() {
    return {
      searchKey: '',
      searchKeyTemp: '',
      searchDelay: 0,
      waypointOptions: {
        active: true,
        callback: this.onWaypoint,
        options: {
          root: null,
          rootMargin: '0px 0px 0px 0px',
          threshold: [0, 1]
        }
      }
    }
  },
  methods: {
    async onWaypoint(waypoint) {
      if (waypoint.going === 'in' && !waypoint.el.classList.contains('loaded')) {
        let photourl = waypoint.el.dataset.photourl
        let contact = JSON.parse(waypoint.el.dataset.contact)

        let visiblename = waypoint.el.dataset.visiblename
        waypoint.el.children[1].innerHTML = visiblename
        if (!photourl || photourl === '' || photourl === null) {
          photourl = '/images/nophoto.png'
        } else {
          let a = await this.getUserPhotos(contact)
          if (a === '') {
            waypoint.el.children[0].src = '/images/nophoto.png'
          } else {
            waypoint.el.children[0].src = a
          }
        }

        waypoint.el.classList.add('loaded')
      }
    },
    async getUserPhotos(Contact) {
      if (Contact.PhotoURL === null) {
      }
      if (Contact === undefined || Contact.PhotoURL === undefined) {
        return ''
      }
      if (this.$config === undefined) {
        return ''
      }
      if (Contact.PhotoURL.includes('http') || Contact.PhotoURL.includes('nophoto.png')) {
        return this.makeBlob(Contact.PhotoURL, Contact.PhotoURL)
      } else {
        let key = '6a61e395-b49a-4468-bee0-27644e95308f'
        var iv = key
          .split('')
          .reverse()
          .join('')
        let encryptedBody = this.ewk(Contact.PhotoURL, key, iv)
        return this.makeBlob(process.env.VUE_APP_UPLOADURL2 + '/gfe?fn=' + Contact.PhotoURL + '&s=' + encodeURIComponent(encryptedBody), Contact.PhotoURL)
      }
    },

    changeSearchKeyWithTimer(searchKey) {
      var vm = this
      if (searchKey !== vm.searchKeyTemp) {
        vm.searchKeyTemp = searchKey
        vm.searchDelay = 3
        vm.changeSearchKeyWithTimer(searchKey)
      } else {
        vm.searchDelay--
        vm.searchDelay = vm.searchDelay < 0 ? 0 : vm.searchDelay
        if (vm.searchDelay > 0) {
          setTimeout(function() {
            if (searchKey === vm.searchKeyTemp) {
              vm.changeSearchKeyWithTimer(vm.searchKeyTemp)
            }
          }, 500)
        } else {
          vm.searchKey = searchKey
        }
      }
    },

    closeContactsListColumn() {
      this.$refs.searchInput.value = ''
      this.searchKey = ''
      this.$store.state.display.leftColumn.newConversation.isExpanded = false
    },

    getLetterFilteredContacts(letter) {
      return this.$store.getters.filteredContacts
        .filter(contact => contact.VisibleName && contact.VisibleName.charAt(0).toLocaleUpperCase('tr') === letter)
        .filter(contact => {
          if (this.searchKey === '') {
            return contact
          }
          return contact.VisibleName.toLocaleLowerCase('tr').includes(this.searchKey.toLocaleLowerCase('tr')) ? contact : null
        })
    },

    createNewGroupClicked() {
      EventBus.$emit('createNewGroupClicked')
    },

    addNewConversation(contact) {
      var buddyID = contact.UserID
      var n = this.$store.state.session.user.UserID.localeCompare(buddyID)
      var merged = n === -1 ? this.$store.state.session.user.UserID + buddyID : buddyID + this.$store.state.session.user.UserID
      var newConvId = CryptoJS.MD5(merged).toString()

      var conv = this.sortedConversationsComputed.find(c => c.ConversationID === newConvId)
      if (conv === undefined) {
        conv = {
          ConversationID: newConvId,
          CreateDate: moment().format('YYYY-MM-DD HH:mm:ss.SSS'),
          Status: 0,
          ContactID: buddyID,
          isBuddyWriting: false,
          Contact: this.$store.getters.getUserById(buddyID),
          Messages: [],
          LastMessage: {}
        }
        this.$store.dispatch('addNewConversation', conv)
      }

      this.$store.state.conversation.activeConversation = conv
      this.$store.state.display.leftColumn.newConversation.isExpanded = false
    }
  }
}
</script>

<style lang="less" scoped>
.contactListInnerMain {
  height: calc(100% - 0px);
  width: 100%;
  display: flex;
  flex-direction: column;
}

.contactListContainer {
  background-color: rgb(230, 232, 255);
  width: calc(100% - 0px);
  height: calc(100% - 0px);
  overflow-y: scroll;
  overflow-x: hidden;
}

.contactListContainer::-webkit-scrollbar {
  width: 2px;
}

.contactListContainer::-webkit-scrollbar-thumb {
  background-color: rgb(155, 155, 155);
}
</style>

<style scoped>
.topBar {
  background-color: var(--topBarColor);
  height: 80px;
  display: flex;
  align-items: flex-end;
  flex-grow: 0;
  flex-shrink: 0;
}

.topBarTitle {
  color: white;
  font-size: 16px;
  font-weight: 700;
  margin: 10px;
  line-height: 40px;
}

.closeColumnBtn {
  cursor: pointer;
}

.closeColumnBtn > img {
  width: 30px;
  height: 30px;
  margin: 10px;
  margin-left: 20px;
}

.letterHeader {
  color: var(--fontColor);
  padding: 10px;
  font-weight: 700;
  background-color: #eaeceb;
}

.searchBar {
  padding: 5px;
  background-color: #eaeceb;
  border-bottom: 1px solid rgb(209, 209, 209);
  display: flex;
}

.searchBar > input {
  border: none;
  flex-grow: 1;
}

.searchBar > input:focus {
  outline: none;
}

.searchBarLeftIcon {
  background-color: white;
  width: 30px;
  height: 30px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
}

.searchBarRightIcon {
  background-color: white;
  width: 30px;
  height: 30px;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
}

.newGroupContainer {
  display: flex;
  padding: 10px;
  align-items: center;
  background-color: white;
  cursor: pointer;
}

.newGroupIcon {
  background-color: var(--buttonColor);
  width: 50px;
  height: 50px;
  border-radius: 25px;
  margin-right: 10px;
}
</style>
